// import { attempt, create } from "lodash";

// replace hard-coded URLs with env-based values (fallback to previous constants)
export const BASE_URL_AUTH =
  process.env.REACT_APP_BASE_URL_AUTH;
export const BASE_URL =
  process.env.REACT_APP_BASE_URL; // base URl
// export const BASE_URL = "http://localhost:4321/"; // base URl
export const CLIENT_ID = "addc0605-1e9a-4abc-bd3e-3a02ecfb4364";
export const REDIRECT_URI = "http://localhost:5173/enterprises";
export const CLIENT_SECRET =
  "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCXzZerpx9qdaelwt1U7NCpWXQKkm1OW4ohDF/7g01xDtYf8Nox9wzhhVQrFD+G4eaJoWxIhJYQTgT4ijMlpjXs07McwktcMX49h6Eoo6ZddOMl380UpivkaO+h80miG4JCFAM0G0pUoeNT8h6L9zHqr/yEoBRd3RAsqxeCKwKrswIDAQAB";
export const STATE = "myState";
export const GRAND_TYPE = "authorization_code";
export const RESPONSE_TYPE = "code";

const version = "v2"; // To control the API version
export const ENDPOINT_URL = {
  auth: {
    // https://apipluto.projectzerozilla.com/v1/iCR2Y/u53rs4u7h1l09in
    login: `/v2/iCR2Y/u53rs4u7h1l09in`,
    logout: `${version}/iCR2Y/X918ByG1hVUKatj`,
  },
  keygenreration: {
    create: `${version}/P7Y4Y/awdH6VteQbIX7ym`,
    getGenerationkeys: `${version}/P7Y4Y/nKvx02eZCZ5hWD5`,
    sent: `${version}/P7Y4Y/LIAJvH1UCNVgS1M`,
    listofGenratescreener: `${version}/G5OIJ/FlwjwAOesY2ZMVl`,
  },
  sticher: {
    create: `${version}/G5OIJ/D0Aj0iG7Kh9RHo3`,
  },
  elements: {
    left_side_bar: `${version}/rXos1/xDO7as9PXrvJ6Jy`,
  },
  global_search: {
    main_search: `${version}/rXos1/J4dG8xLpM2aR9eK`,
  },
  enterprise: {
    create: `${version}/P7Y4Y/rp6RaU3pdk6O63i`,
    getinterprise: `${version}/J2nve/VcMLIlIlQdVcw8G`,
    delete: `${version}/J2nve/J1HZlRXTzDEdUko`,
    edit: `${version}/J2nve/CaQzTD6mC8VzHg1`,
    fetchkeysvalue: `${version}/J2nve/xLoZneo6fA93l8x`,
    fetchpreviouslicensedetails: `${version}/J2nve/wLnMoL8Egm3v8hK`,
    orgadminlist: `${version}/J2nve/UB1oBK8mvtleI94`,
    createuser: `${version}/J2nve/oUBdgmQDDyzBbJp`,
    addenterpriseforstcher: `${version}/G5OIJ/SseJ74rHufMTTgb`,
  },
   user_heartbeat: {
    userheartbeat: `${version}/iCR2Y/KayGjX91t8B1hVU`,
  },
};
